<template>
  <div class="ym-iframe">
    <iframe :src="src"
            frameborder="0"
            height="100%"
    ></iframe>
  </div>
</template>

<script>
  export default {
    name: 'YmIframe',
    props: {
      src: {
        type: String,
        required: true,
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  iframe {
    display: block;
    margin: 0 auto;
    width: 750px;
  }

</style>
